import { Submittal } from '.'
import { ComplexEnumItem } from '../../../utils/complexEnum/ComplexEnumItem'
import { NotificationEventItem } from '../NotificationEventItem'

/**
 * generates a common NotificationEventItem for disposition given notification events
 *
 * ---
 *
 * the description is: `A router gives their final disposition on a ${submittal} and locks it`
 *
 * @param options {@link DispositionGivenOptions}
 * @see {@link NotificationEventItem}
 */
export function DispositionGivenNotificationEventItem<
  ID extends Lowercase<string>
>(
  options: DispositionGivenOptions<ID>
): NotificationEventItem<'Disposition Given', ID>
/**
 * generates a common NotificationEventItem for disposition given notification events
 *
 * ---
 *
 * the description is: `A router gives their final disposition on a ${submittal} and locks it`
 *
 * @param options {@link DispositionGivenOptions}
 * @see {@link NotificationEventItem}
 */
export function DispositionGivenNotificationEventItem<
  ID extends Lowercase<string>,
  Name extends string
>(
  options: DispositionGivenOptions<ID> & { name: Name }
): NotificationEventItem<Name, ID>
// implementation
export function DispositionGivenNotificationEventItem<
  ID extends Lowercase<string>,
  Name extends string = 'Disposition Given'
>({ submittal, id, name }: DispositionGivenOptions<ID> & { name?: Name }) {
  return new NotificationEventItem({
    id,
    name: name ?? 'Disposition Given',
    description: `A router gives their final disposition on a ${submittal} and locks it`,
  })
}

type DispositionGivenOptions<T extends Lowercase<string>> = Pick<
  ComplexEnumItem<T>,
  'id'
> & {
  /**
   * which submittal object can have a disposition given
   */
  submittal: Submittal
}
